/**
 * 处理图片 URL，统一添加参数
 * @param src - 原始图片 URL
 * @param params - 额外的查询参数（可选）
 * @returns 添加参数后的图片 URL
 */
export function processImageUrl(src: string | undefined | null, params?: Record<string, string>): string | undefined {
  if (!src) return undefined;

  // 跳过非 http/https 的 URL（如本地路径、data URI）
  if (!src.startsWith('http')) return src;

  //跳过svg跟gif（检查文件扩展名，忽略查询参数）
  const urlObj = new URL(src);
  const ext = urlObj.pathname.split('.').pop()?.toLowerCase();
  if (ext === 'svg' || ext === 'gif') return src;

  try {
    // 解析现有 URL
    const url = new URL(src);
    
    // 添加统一参数（这里可以自定义需要添加的参数）
    // 检测参数是否包含x-oss-process=image/resize，是的话在此参数增加水印
    const existingProcess = url.searchParams.get('x-oss-process');
    const watermark = 'watermark,text_aHR0cHM6Ly93d3cueXktdGFuay5jb20v,t_01,color_FFFFFF,size_30,fill_1';
    
    if (!existingProcess) {
      // 如果没有处理参数，默认添加水印
      url.searchParams.set('x-oss-process', `image/resize,m_lfit,w_1920/${watermark}`);
    } else if (existingProcess.includes('image/resize') && !existingProcess.includes('watermark')) {
      // 如果已存在 image/resize 参数且没有水印，追加水印参数并将m_fixed改为m_lfit
      let newProcess = existingProcess;
      // 将 m_fixed 改为 m_lfit
      newProcess = newProcess.replace(/m_fixed/g, 'm_lfit');
      url.searchParams.set('x-oss-process', `${newProcess}/${watermark}`);
    }

    // 添加额外传入的参数
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
    }

    return url.toString();
  } catch {
    // 如果 URL 解析失败，返回原始 URL
    return src;
  }
}